var styles = {"titleLockupWrapper":"VDS__MON__title-lockup-module__OVlJt","center":"VDS__MON__title-lockup-module__47KC5"};

export { styles as default };
